/******************************************************************************************
 *	Address Form Directive
 *******************************************************************************************
 *
 * Changes element order in DOM to obtain locale-specific formats.
 *
 */
(function() {
  

  angular.module('rcDirectives.addressForm', []).directive(
    'rcAddressForm',
    /* @ngInject */
    function($rootScope, Languages) {
      return {
        restrict: 'A',
        link: function(scope, element) {
          //Tracks if the format was changed in order to know when to revert
          var formatChanged = false;

          //DOM elements
          var streetRow = element[0].querySelector('.js-address-row-street');
          var othersRow = element[0].querySelector('.js-address-row-others');
          var cityColumn = element[0].querySelector('.js-address-column-city');
          var stateColumn = element[0].querySelector('.js-address-column-state');
          var zipCodeColumn = element[0].querySelector('.js-address-column-zipCode');

          if (streetRow && othersRow && cityColumn && stateColumn && zipCodeColumn) {
            // Asian locales require a different format
            if (Languages.invertAddress()) {
              formatChanged = true;

              //Swap street row with city-state-zip row vertically
              element[0].insertBefore(othersRow, streetRow);

              //Swap Zip Code with City
              othersRow.insertBefore(zipCodeColumn, cityColumn); //Move ZIP Code before City
              othersRow.insertBefore(stateColumn, cityColumn); //Move State before City
            } else if (formatChanged) {
              formatChanged = false;

              //Swap street row with city-state-zip row vertically
              element[0].insertBefore(streetRow, othersRow);

              //Swap Zip Code with City
              othersRow.insertBefore(cityColumn, zipCodeColumn);
              othersRow.insertBefore(stateColumn, zipCodeColumn);
            }
          }
        }
      };
    }
  );
})();
